const _globals: any = [];

export default class GlobalUtil {
  static set(name: any, value: any) {
    _globals[name] = value;
  }

  static get(name: any) {
    return _globals[name];
  }
}
